import * as types from '../../../../../constants/ActionNameConstants';

const INITIAL_STATE = {
  loading: false,
  success: false,
  error: null,
};

const MergeCGAFileCollectionDownloadReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.MERGE_CGA_FILE_COLLECTION_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case types.MERGE_CGA_FILE_COLLECTION_DOWNLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
      };
    case types.MERGE_CGA_FILE_COLLECTION_DOWNLOAD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        success: false,
      };
    default:
      return state;
  }
};

export default MergeCGAFileCollectionDownloadReducer;
